// Counterpart of webapp/src/store/globalError.ts

import {create} from 'zustand'

type GlobalErrorState = {
    globalError: string
    setGlobalError: (error: string) => void
}

export const useGlobalError = create<GlobalErrorState>((set) => ({
    globalError: '',
    setGlobalError: (globalError) => set({globalError}),
}))
